import { render } from "./SessionMenu.vue?vue&type=template&id=a3538420&scoped=true"
import script from "./SessionMenu.vue?vue&type=script&lang=js"
export * from "./SessionMenu.vue?vue&type=script&lang=js"

import "./SessionMenu.vue?vue&type=style&index=0&id=a3538420&lang=scss&scoped=true"
import "./SessionMenu.vue?vue&type=style&index=1&id=a3538420&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3538420"]])

export default __exports__